export default __webpack_public_path__ + "static/media/img_about4@2x.min.a46347ac.jpg";